import { Component, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { VWProgram } from '@app/core/models';
import { AppState, selectProgram } from '@app/core/ngrx';
@Component({
  selector: 'ecp-create-shipping-label',
  templateUrl: './create-shipping-label.component.html',
  styleUrls: ['./create-shipping-label.component.scss'],
})
export class CreateShippingLabelComponent {
  public program$: Observable<VWProgram>;
  theme = 'one-portal';
  locationInfo: any = [];
  selectedLab: any = null;
  originInfo: any;
  destinationInfo: any;

  constructor(
    private dialogRef: MatDialogRef<CreateShippingLabelComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.program$ = this.store.pipe(select(selectProgram));
    this.program$.pipe().subscribe(program => {
      if (program) {
        this.theme = program.programKey;
      }
    });
    if (data) {
      this.locationInfo = data?.labLocation;
      this.selectedLab = data?.selectedLab;
      let origin = this.locationInfo.filter(e => {
        if (e.dropshipType.toLowerCase() === 'office') return e;
      });
      let destination = this.locationInfo.filter(e => {
        if (e.frameAccountId == this.selectedLab.frameAccountId) {
          return e;
        }
      });
      this.originInfo = origin[0];
      this.destinationInfo = destination[0];
    }
  }

  @HostListener('document:keydown.escape')
  closeDialog() {
    this.dialogRef.close();
  }
  createShippingLabel(){
    let payload = {
      fromAddress:{
        name: this.originInfo.businessName,
        addressLine1: this.originInfo.streetName,
        city: this.originInfo.city,
        state: this.originInfo.state,
        zip: this.originInfo.postalCode,
      },
      toAddress:{
        name: this.destinationInfo.businessName,
        addressLine1: this.destinationInfo.streetName,
        city: this.destinationInfo.city,
        state: this.destinationInfo.state,
        zip: this.destinationInfo.postalCode,
      }
    }
    this.dialogRef.close(payload);
  }
}
